<template>
    <el-popover v-model="showSelection"
                placement="bottom"
                trigger="click">
        <el-input slot="reference"
                  v-model="value.name"
                  :style="{ width: componentWidth }"
                  :placeholder="`${placeholder}`"
                  :readonly="true"/>
        <div>
            <el-input style="width: 200px" v-model="filterText"
                      :placeholder="`${showName}`"
                      v-if="showSearch"/>
            <el-tree ref="tree"
                     style="padding-top:10px;min-height:300px;max-height: 500px;overflow-y: scroll"
                     :data="treeData"
                     :node-key="rowKeys.id"
                     :show-checkbox="isMulti"
                     @node-click="nodeClick"
                     :current-node-key="value.id"
                     :props="defaultProps"
                     :filter-node-method="filterNode"
                     @check-change="handleCheckChange"
                     @current-change="handleCurrentChange"
                     :highlight-current="!isMulti"/>
        </div>
    </el-popover>
</template>


<script>
    export default {
        name: 'selectTree',
        props: {
            childUrl:{
                type: String,
                default: ""
            },
            placeholder:{
                type: String,
                default: '请选择'
            },
            showName: {
                type: String,
                default: '输入搜索'
            },
            value: {
                type: Object,
                default: () => ({
                    id: '',
                    name: ''
                })
            },
            rowKeys: {
                type: Object,
                default: () => ({
                    id: 'id',
                    name: 'name',
                    children: 'children',
                    parent: 'parentId'
                })
            },
            treeData: {
                type: Array,
                default: () => []
            },
            componentWidth: {
                type: String,
                default: '100%'
            },
            valueType: {
                type: String,
                default: 'all' // all,parent,son；选择all时，所选中的父子节点都返回；选择parent的时候，当前父节点下所有子节点都被选择时，只返回父节点；选择son的时候，当前父节点下所有子节点都被选择时，过滤父节点
            },
            isMulti: {
                type: Boolean,
                default: false
            },
            showSearch: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                //定义点击次数,默认0次
                treeClickCount: 0,
                multipleSelection: [],
                showSelection: false,
                filterText: '',
                selTreeData: {
                    id:""
                },
            }
        },
        computed: {
            defaultProps() {
                return {
                    children: this.rowKeys.children,
                    label: this.rowKeys.name
                }
            }
        },
        watch: {
            filterText(val) {
                this.$refs.tree.filter(val)
            },
            value(val) {
                if (this.isMulti) {
                    this.multiReset()
                } else {
                    this.singleReset()
                }
            },
        },
        mounted() {
            if (this.isMulti) {
                this.multiReset()
            } else {
                this.singleReset()
            }
        },
        methods: {
            async getChildData(id) {
                this.loading = true;
                let param = {
                    url:this.childUrl+id,
                    param:{
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                return data;
            },
            async handleNodeClick(data, node) {
                const res = await this.getChildData(data.id);
                this.$nextTick(() => {   //划重点了  $nextTick 不懂得上网查一下
                    this.$refs["tree"].updateKeyChildren(data.id, res.data.result);
                });
            },
            //点击左边表格
            nodeClick(data) {
                this.selTreeData = data;
                console.info(this.childUrl)
                if(this.childUrl!='' && this.childUrl!=null) {
                    this.handleNodeClick(data);
                }
            },
            multiReset() {
                if (this.value.id) {
                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedKeys(this.value.id.split(','))
                    })
                } else {
                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedKeys([])
                    })
                }
            },
            // 单选设置当前选中节点
            singleReset() {
                if (this.value.id) {
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(this.value.id)
                    })
                }
            },
            // 树菜单搜索
            filterNode(value, data) {
                if (!value) return true
                return data[this.rowKeys.name].indexOf(value) !== -1
            },
            // 选择
            handleCheckChange() {
                const checkNodes = this.$refs.tree.getCheckedNodes()
                if (this.valueType === 'all') {
                    this.multipleSelection = checkNodes
                } else if (this.valueType === 'son') {
                    this.multipleSelection = checkNodes.filter((item) => {
                        return !item.children || item.children.length === 0
                    })
                } else {
                    const parentNodes = checkNodes
                        .filter((item) => {
                            return item.children && item.children.length > 0
                        })
                        .map((i) => i[this.rowKeys.id])
                    let result = []
                    for (const j of checkNodes) {
                        if (!parentNodes.includes(j[this.rowKeys.parent])) {
                            result.push(j)
                        }
                    }
                    this.multipleSelection = result
                }
                this.submit()
            },
            // 多选提交选择信息
            submit() {
                const checkedIds = this.multipleSelection
                    .map((item) => item[this.rowKeys.id])
                    .join(',')
                const checkedNames = this.multipleSelection
                    .map((item) => item[this.rowKeys.name])
                    .join(',')
                this.$emit('input', {id: checkedIds, name: checkedNames}) // 传值给父组件
            },
            // 单选提交选择信息
            handleCurrentChange(data) {
                //处理双击选中用
                if (!this.isMulti) {
                    if (data.id === this.value.id){
                        this.treeClickCount++;
                    }else{
                        this.treeClickCount = 1;
                    }
                    //计时器,计算300毫秒为单位,可自行修改
                    this.timer = window.setTimeout(() => {
                        if (this.treeClickCount == 1) {
                            //把次数归零
                            this.treeClickCount = 0;
                        } else if (this.treeClickCount > 1) {
                            //把次数归零
                            this.treeClickCount = 0;
                            this.showSelection = false;
                        }
                    }, 300);
                }

                if (!this.isMulti) {
                    this.$emit('input', {
                        id: data[this.rowKeys.id],
                        name: data[this.rowKeys.name]
                    })
                    this.$emit('setData',data)
                } // 传值给父组件
            },
        }
    }
</script>

<style scoped>
    /deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        background-color: #409eff;
        border-radius: 10px;
        color: white;
    }
    /deep/ .el-input__inner{
        -webkit-appearance: none;
        background-color: #FFF;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 35px;
        line-height: 40px;
        outline: 0;
        /* padding: 0 15px; */
        -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 200px;
    }
</style>